import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import stateCityData from "../../../data/states.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser, faEnvelope, faPhoneAlt, faIdCard, faCalendar, faTint,
  faMapMarkerAlt, faCity, faEye, faEyeSlash, faVenusMars
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const PodcastRegister = () => {

  const [showOtpFields, setShowOtpFields] = useState(false);
  const [timer, setTimer] = useState(180);
  const [isResending, setIsResending] = useState(false);
  const [canResendOTP, setCanResendOTP] = useState(false);
  const [otpData, setOtpData] = useState({ otpEmail: "" });
  const navigate = useNavigate();



  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    email: "",
    phoneNo: "",
    aadharNo: "",
    dateOfBirth: "",
    pancard: "",
    residenceAddress: "",
    state: "",
    city: "",
    pincode: "",
    termsAccepted: false
  });

  // Use JSON structure: { state: [cities] }
  const [states] = useState(Object.keys(stateCityData));
  const [filteredCities, setFilteredCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState('');



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phoneNo") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: digitsOnly });
    } else if (name === "aadharNo") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      setFormData({ ...formData, [name]: digitsOnly });
    } else if (name === "name") {
      const lettersOnly = value.replace(/[^A-Za-z\s]/g, "");
      setFormData({ ...formData, [name]: lettersOnly });
    } else if (name === "pancard") {
      let pancardValue = value.toUpperCase().replace(/[^0-9A-Z]/g, "");
      pancardValue = pancardValue.slice(0, 10);
      setFormData({ ...formData, [name]: pancardValue });
    } else if (name === "pincode") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 6);
      setFormData({ ...formData, [name]: digitsOnly });
    } else if (name === "termsAccepted") {
      setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setFormError("");
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setFormData({
      ...formData,
      state: selectedState,
      city: ""
    });
    // Set cities for selected state
    if (selectedState && Array.isArray(stateCityData[selectedState])) {
      setFilteredCities(stateCityData[selectedState]);
    } else {
      setFilteredCities([]);
    }
  }

  const validateForm = () => {
    // List of required fields and their labels
    const requiredFields = [
      { key: 'name', label: 'Full Name' },
      { key: 'gender', label: 'Gender' },
      { key: 'email', label: 'Email' },
      { key: 'phoneNo', label: 'PhoneNo' },
      { key: 'aadharNo', label: 'Aadhar Number' },
      { key: 'dateOfBirth', label: 'Date of Birth' },
      { key: 'pancard', label: 'PAN Card' },
      { key: 'residenceAddress', label: 'Residence Address' },
      { key: 'state', label: 'State' },
      { key: 'city', label: 'City' },
      { key: 'pincode', label: 'PinCode' },
      { key: 'termsAccepted', label: 'Terms and Conditions' },
    ];
    const missingFields = requiredFields.filter(f => !formData[f.key]);
    if (missingFields.length > 0) {
      const missingLabels = missingFields.map(f => f.label).join(', ');
      setFormError(`Please fill the following field${missingFields.length > 1 ? 's' : ''}: ${missingLabels}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Name: only letters and spaces
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name)) {
      setFormError("Name must contain only letters and spaces (no numbers allowed)");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFormError("Please enter a valid email address");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Only allow @gmail.com
    if (!formData.email.endsWith('@gmail.com')) {
      setFormError("Only @gmail.com email addresses are allowed");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Mobile: exactly 10 digits
    const phoneNoRegex = /^\d{10}$/;
    if (!phoneNoRegex.test(formData.phoneNo)) {
      setFormError("Phone number must be exactly 10 digits.");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Aadhar: exactly 12 digits
    const aadharRegex = /^\d{12}$/;
    if (!aadharRegex.test(formData.aadharNo)) {
      setFormError("Aadhar number must be exactly 12 digits.");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // PAN: 10 chars, 4 digits, 6 uppercase letters
    const pancardRegex = /^[A-Z0-9]{10}$/;
    if (!pancardRegex.test(formData.pancard)) {
      setFormError("PAN card number must be 10 characters, only uppercase letters and digits");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const digitCount = (formData.pancard.match(/\d/g) || []).length;
    const letterCount = (formData.pancard.match(/[A-Z]/g) || []).length;
    if (digitCount !== 4 || letterCount !== 6) {
      setFormError("PAN card number must have exactly 4 digits and 6 uppercase letters (any order)");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // DOB: must be in the past and above 13 years
    if (!formData.dateOfBirth) {
      setFormError("Date of birth is required.");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const today = new Date();
    const dob = new Date(formData.dateOfBirth);
    if (dob >= today) {
      setFormError("Date of birth must be in the past");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const minAge = 13;
    const yearDiff = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();
    let isAbove13 = false;
    if (yearDiff > minAge) {
      isAbove13 = true;
    } else if (yearDiff === minAge) {
      if (monthDiff > 0) {
        isAbove13 = true;
      } else if (monthDiff === 0 && dayDiff > 0) {
        isAbove13 = true;
      }
    }
    if (!isAbove13) {
      setFormError("You must be above 13 years old to register");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Pincode: exactly 6 digits
    const pincodeRegex = /^\d{6}$/;
    if (!pincodeRegex.test(formData.pincode)) {
      setFormError("Pincode must be exactly 6 digits.");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Terms
    if (!formData.termsAccepted) {
      setFormError("You must accept the terms and conditions");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError("");
    e.preventDefault();
    setIsSubmitting(true);
    setFormError("");

    // Validate form before submission
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/podcast/register`,
        {
          ...formData
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Registration response:", response);
      // Show toast based on response status
      if (response.status === 200) {
        toast.success("OTP sent to your email. Please verify within 3 minutes.");
        setShowOtpFields(true);
        setTimer(180);
      } else if (response.status === 400) {
        toast.error(response.data.message || "User already exists. Please login.");
        setTimeout(() => {
          navigate("/podcast/login");
        }, 2000);
      } else if (response.status === 500) {
        toast.error("Internal server error. Please try again later.");
      } else {
        toast.error(response.data.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message || "Invalid input. Please check your details.");
          if (error.response.data.message === "User already exists. Please log in.") {
            setTimeout(() => {
              navigate("/podcast/login");
            }, 2000);
          }
        } else if (error.response.status === 500) {
          toast.error("Internal server error. Please try again later.");
        } else {
          toast.error(error.response.data.message || "Registration failed. Please try again.");
        }
      } else {
        toast.error("Network error. Please try again.");
      }
    }
    setIsSubmitting(false);
  };


  // Timer effect for OTP modal
  useEffect(() => {
    if (!showOtpFields) return;
    if (timer > 0) {
      const timeout = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearTimeout(timeout);
    } else {
      setCanResendOTP(true);
      setTimeout(() => window.location.reload(), 300);
    }
  }, [timer, showOtpFields]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleOtpChange = (e) => {
    setOtpData({
      ...otpData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/podcast/verifyOtp`,
        {
          phoneNo: formData.phoneNo,
          email: formData.email,
          emailOtp: otpData.otpEmail,
        }
      );
      console.log("OTP verification response:", response);

      if (response.status === 404) {
        toast.error("User not found or already verified.");
        navigate("/podcast/register");
      } else if (response.status === 200 && response.data?.success) {
        // Save token to localStorage if available
        if (response.data.data?.token) {
          localStorage.setItem("token", response.data.data.token);
        }
        toast.success("OTP verified successfully. Registration completed. Redirecting to login...");
        // Close OTP modal immediately
        setShowOtpFields(false);
        // Clear form data
        setFormData({
          name: "",
          gender: "",
          email: "",
          phoneNo: "",
          aadharNo: "",
          dateOfBirth: "",
          pancard: "",
          residenceAddress: "",
          state: "",
          city: "",
          pincode: "",
          password: "",
          confirmPassword: "",
        });
        // Redirect after a short delay
        setTimeout(() => {
          navigate("/podcast/login");
        }, 1500);
      } else {
        setFormError(response.data.message || "OTP verification failed");
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        toast.error("Internal server error. Please try again later.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const handleResendOTP = async () => {
    setIsResending(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/resend-otp`,
        {
          email: formData.email,
          phoneNo: formData.phoneNo,
        }
      );

      if (response.data.success) {
        // Reset timer
        setTimer(180);
        setCanResendOTP(false);
        alert("OTP resent successfully!");
      } else {
        alert(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to resend OTP");
    } finally {
      setIsResending(false);
    }
  };

  // Initialize filteredCities if editing or state is pre-filled
  useEffect(() => {
    if (formData.state && Array.isArray(stateCityData[formData.state])) {
      setFilteredCities(stateCityData[formData.state]);
    } else {
      setFilteredCities([]);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8 pt-20">

      {/* OTP Verification Modal */}
      {showOtpFields && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"></div>
          <div className="bg-white w-full max-w-md mx-auto p-8 rounded-[2rem] shadow-2xl shadow-indigo-500/20 relative animate-fadeIn border border-slate-100">
            <button
              onClick={() => setShowOtpFields(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-400 hover:bg-red-50 hover:text-red-500 transition-colors"
              aria-label="Close OTP Modal"
            >
              <span className="text-xl leading-none font-bold">&times;</span>
            </button>
            <div className="flex flex-col items-center justify-center mb-6">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <h3 className="text-2xl font-[1000] text-slate-800 uppercase tracking-tight mb-1">
                Verify OTP
              </h3>
              <div className="text-[10px] uppercase tracking-widest font-black text-rose-500 bg-rose-50 px-3 py-1 rounded-full mt-2 border border-rose-100 shadow-sm">
                Time remaining: {formatTime(timer)}
              </div>
            </div>

            <form onSubmit={handleOtpSubmit} className="space-y-5">
              <div className="space-y-1.5">
                <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1">Email OTP</label>
                <input
                  type="text"
                  id="otpEmail"
                  name="otpEmail"
                  maxLength={6}
                  value={otpData.otpEmail}
                  onChange={handleOtpChange}
                  className="block w-full px-4 py-3 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 tracking-[0.2em] text-center"
                  placeholder="------"
                />
                <p className="mt-1 text-[10px] font-bold text-slate-400 text-center">Check your email {formData.email}</p>
              </div>
              <div className="flex flex-col gap-3 mt-6 pt-2">
                <button
                  type="submit"
                  className="w-full flex justify-center py-3.5 px-4 rounded-xl shadow-lg shadow-emerald-200/50 text-sm font-black text-white bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 active:scale-[0.98] transition-all uppercase tracking-widest"
                >
                  Verify OTP
                </button>
                <button
                  type="button"
                  onClick={handleResendOTP}
                  disabled={!canResendOTP || isResending}
                  className={`w-full flex justify-center py-3.5 px-4 rounded-xl text-sm font-black transition-all uppercase tracking-widest ${canResendOTP && !isResending ? "text-indigo-600 bg-indigo-50 hover:bg-indigo-100 active:scale-[0.98] border-2 border-indigo-100 hover:border-indigo-200" : "text-slate-400 bg-slate-50 border-2 border-slate-100 cursor-not-allowed"}`}
                >
                  {isResending ? "Resending..." : "Resend OTP"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="w-full max-w-6xl mx-auto bg-white rounded-[2rem] shadow-2xl shadow-indigo-200/50 overflow-hidden border border-slate-100 min-h-[700px]">
        <div className="flex flex-col lg:flex-row h-full">
          {/* Left side - Company Branding */}
          <div className="hidden lg:flex lg:w-5/12 bg-gradient-to-br from-indigo-700 via-blue-600 to-indigo-900 p-10 relative overflow-hidden flex-col justify-center items-center">
            {/* Abstract Background Elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -mr-20 -mt-20"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-indigo-400 opacity-20 rounded-full blur-2xl -ml-10 -mb-10"></div>

            <div className="relative z-10 flex flex-col justify-center items-center text-white text-center">
              <div className="w-20 h-20 mb-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl flex items-center justify-center shadow-lg transform transition-transform duration-500 hover:scale-105">
                <img
                  src="/images/iinsaf.png"
                  alt="IINSAF Logo"
                  className="w-14 h-auto filter brightness-110 drop-shadow-md"
                />
              </div>

              <h1 className="text-4xl font-[1000] tracking-tight mb-4 drop-shadow-sm uppercase">Join IINSAF <br /><span className="text-indigo-200 text-2xl font-bold">Podcast Studio</span></h1>
              <p className="text-indigo-100 font-bold tracking-wide text-sm opacity-90 max-w-xs mx-auto leading-relaxed mb-8">
                Create your account and start sharing your voice with the world.
              </p>

              <div className="space-y-4 text-left w-full max-w-[250px] mx-auto">
                <div className="flex items-center text-indigo-50 bg-white/5 p-3 rounded-xl border border-white/10 backdrop-blur-sm">
                  <div className="bg-indigo-500/50 p-2 rounded-lg mr-3 text-white">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wide">Exclusive Access</span>
                </div>
                <div className="flex items-center text-indigo-50 bg-white/5 p-3 rounded-xl border border-white/10 backdrop-blur-sm">
                  <div className="bg-indigo-500/50 p-2 rounded-lg mr-3 text-white">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wide">Global Reach</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - Form */}
          <div className="w-full lg:w-7/12 p-6 sm:p-10 lg:p-12 flex flex-col bg-white justify-center h-full">
            <div className="mb-8 text-center lg:text-left animate-fadeIn">
              <h1 className="text-3xl sm:text-4xl font-[1000] text-slate-900 tracking-tight mb-2 uppercase">
                Register
              </h1>
              <div className="w-12 h-1.5 bg-indigo-600 rounded-full mb-3 mx-auto lg:mx-0"></div>
              <p className="text-xs font-bold text-slate-500 tracking-wide uppercase">
                Create Your Account
              </p>
            </div>

            {/* Registration form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              {formError && (
                <div className="bg-red-50 border border-red-200 text-red-700 p-2 rounded-md text-xs font-medium">
                  {formError}
                </div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {/* Name Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Full Name
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faUser} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                </div>
                {/* Gender Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Gender
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faVenusMars} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                {/* Email Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Email
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faEnvelope} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>
                {/* Phone Number Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Phone Number
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faPhoneAlt} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="tel"
                      name="phoneNo"
                      value={formData.phoneNo}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>
                </div>
                {/* Aadhar Card field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Aadhar Number
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faIdCard} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="text"
                      name="aadharNo"
                      value={formData.aadharNo}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your 12-digit Aadhar number"
                      pattern="[0-9]{12}"
                      maxLength="12"
                    />
                  </div>
                </div>
                {/* PAN Card field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    PAN Card
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faIdCard} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="text"
                      name="pancard"
                      value={formData.pancard}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your PAN card number"
                    />
                  </div>
                </div>
                {/* Date of Birth field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Date of Birth
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faCalendar} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                    />
                  </div>
                </div>
                {/*  Address Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Residence Address
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faMapMarkerAlt} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <input
                      type="text"
                      name="residenceAddress"
                      value={formData.residenceAddress}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your residence address"
                    />
                  </div>
                </div>
                {/* State Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    State
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faMapMarkerAlt} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleStateChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                    >
                      <option value="">Select State</option>
                      {states.map((state, index) => (
                        <option key={index} value={state}>{state}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* City Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    City
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faCity} className="text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                    </div>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                      disabled={!formData.state}
                    >
                      <option value="">{formData.state ? "Select City" : "Select State First"}</option>
                      {filteredCities.map((city, index) => (
                        <option key={index} value={city}>{city}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* Pincode Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Pin Code
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      className="block w-full pl-4 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Enter your 6-digit pincode"
                      maxLength="6"
                    />
                  </div>
                </div>
              </div>
              {/* Terms and Conditions */}
              <div className="flex items-start mt-4 bg-slate-50 p-3 rounded-xl border border-slate-100">
                <div className="flex items-center h-5">
                  <input
                    type="checkbox"
                    name="termsAccepted"
                    checked={formData.termsAccepted}
                    onChange={handleChange}
                    className="w-4 h-4 text-indigo-600 bg-white border-2 border-slate-300 rounded focus:ring-indigo-500"
                    required
                  />
                </div>
                <div className="ml-3 text-xs font-bold text-slate-600 leading-relaxed pt-[2px]">
                  I accept the <span
                    className="text-indigo-600 hover:text-indigo-700 underline cursor-pointer"
                    onClick={() => window.open('/termscondition', '_blank')}
                  >
                    terms and conditions
                  </span> of IINSAF.
                </div>
              </div>

              <div className="mt-8 pt-2">
                <button
                  type="submit"
                  className={`w-full flex justify-center items-center py-3.5 px-4 rounded-xl shadow-lg shadow-indigo-200/50 text-sm font-black text-white bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 active:scale-[0.98] transition-all uppercase tracking-widest ${isSubmitting ? "opacity-70 cursor-not-allowed" : ""}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="flex items-center">
                      <svg className="animate-spin h-5 w-5 mr-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                      </svg>
                      PROCESSING ACCOUNT...
                    </span>
                  ) : (
                    "CREATE ACCOUNT"
                  )}
                </button>
              </div>

              <div className="text-center mt-3">
                <span className="text-xs text-slate-600 font-bold">Already have an account? </span>
                <Link to="/podcast/login" className="inline-flex items-center text-indigo-600 font-black ml-1 hover:underline text-xs tracking-wider uppercase">
                  Sign in
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodcastRegister;
